'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoRepoPush = function GoRepoPush(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm22.5 12.5l-7.5 10h5v17.5h5v-17.5h5l-7.5-10z m-7.5 0h2.5v-2.5h-2.5v2.5z m2.5-7.5h-2.5v2.5h2.5v-2.5z m15-5h-25s-2.5 1.3-2.5 2.5v30s1.3 2.5 2.5 2.5h5v5l5-5v-5h-5v2.5h-3.7s-1.3-0.5-1.3-1.2v-3.8h10v-2.5h-5v-22.5h20l0 22.5h-5v2.5h5v3.8s-0.6 1.2-1.2 1.2h-3.8v2.5h5s2.5-1.2 2.5-2.5v-30s-1.2-2.5-2.5-2.5z' })
        )
    );
};

exports.default = GoRepoPush;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/repo-push.js
// module id = 2001
// module chunks = 0